import { useEffect, useState } from 'react';
import { useApp } from '../../../contexts';
import api from '../../../services/api';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Text } from '../index'
import { Checkbox } from '../index'
import { format } from 'date-fns';

export default function LGPDAccordionContactDetails({ contactId }) {

  const { setLoading, closeDialog, showDialog } = useApp();
  const [contact, setContact] = useState(null)

  useEffect(() => {
    loadContactLGPDData(contactId)
  }, [])

  const loadContactLGPDData = (contactId) => {
    setLoading(true)
    api.get(`/contact/${contactId}/lpgd`).then(response => {
      setLoading(false)
      setContact(response.data)
    }).catch(err => {
      setLoading(false)
    })
  }

  const handleSelect = (field, index, event) => {
    const { checked } = event.target

    let newArrayValue = contact[field]
    newArrayValue[index].checked = checked

    setContact({
      ...contact,
      [field]: newArrayValue
    })
  }

  const handleChangeUserData = (event) => {
    const { checked } = event.target

    setContact({
      ...contact,
      contact: {
        ...contact.contact,
        checked
      }
    })
  }

  const selectAll = (field, event) => {

    const { checked } = event.target

    let newArrayValue = contact[field]
    newArrayValue = newArrayValue.map(item => {
      return {
        ...item,
        checked
      }
    })

    setContact({
      ...contact,
      [field]: newArrayValue
    })
  }

  const handleAnonimyzeConfirmation = () => {

    showDialog({
      title: `Anonimização LGPD - ${contact.contact.nome_contato}`,
      component: <Typography sx={{ fontSize: 16 }}>Tem certeza que deseja anonimizar os items selecionados deste contato?</Typography>,
      confirmLabelButton: 'Anonimizar',
      showCancelButton: true,
      showConfirmButton: true,
      handleConfirm: () => handleAnonimyze()
    })

  }

  const handleAnonimyze = () => {
    let anonimyzeData = {
      contact: contact.contact.checked ? contact.contact.id_contato : false,
      adresses: contact.adresses.filter(item => item.checked).map(item => item.id_endereco),
      apps: contact.apps.filter(item => item.checked).map(item => item.id_sistema_acesso),
      companies: contact.companies.filter(item => item.checked).map(item => item.id_contato_empresa),
      emails: contact.emails.filter(item => item.checked).map(item => item.id_email),
      phoneNumbers: contact.phoneNumbers.filter(item => item.checked).map(item => item.id_telefone),
      updates: contact.updates.filter(app => app.checked).map(app => app.id_dados),
      interactions: contact.interactions.filter(interaction => interaction.checked).map(interaction => interaction.id_contato_interacao),
      rdstationLeads: contact.rdstationLeads.filter(lead => lead.checked).map(lead => lead.uuid)
    }

    api.post(`/contact/${contactId}/lpgd/anonimyze`, {anonimyzeData}).then(response=>{

      showDialog({
        title: `Anonimização LGPD - ${contact.contact.nome_contato}`,
        component: <Typography sx={{ fontSize: 16 }}>Dados anonimizados com sucesso</Typography>,
        showConfirmButton: true,
        handleConfirm: () => closeDialog(),
        confirmLabelButton: 'Ok'
      })
    })
  }


  const handleCancel = () => {
    closeDialog()
  }

  if (contact) return (
    <div>
      <Accordion
        expanded>
        <AccordionSummary
          aria-controls="panel1a-content"
          id="panel1a-header"
        >

        </AccordionSummary>
        <AccordionDetails>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <Checkbox checked={contact.checked} onChange={handleChangeUserData} />
            <div style={{ flexDirection: 'column', flex: 1 }}>
              <ContactDetailsRow label='Nome' value={contact?.contact?.nome_contato} />
              <ContactDetailsRow label='CPF' value={contact?.contact?.cpf_cnpj} />
              <ContactDetailsRow label='RG' value={contact?.contact?.rg} />
              <ContactDetailsRow label='Linkedin' value={contact?.contact?.linkedin} />
            </div>
          </div>

        </AccordionDetails>
      </Accordion>
      {contact?.phoneNumbers.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel2a-header"
          >
            <Typography>Telefones ({contact?.phoneNumbers.length})</Typography>

          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox checked={contact?.phoneNumbers.filter(item => item.checked).length == contact?.phoneNumbers.length} onChange={(event) => selectAll('phoneNumbers', event)} />
              <Typography sx={{ fontSize: 12 }}>Selecionar todos os telefones</Typography>
            </div>
            {contact?.phoneNumbers.map((phoneNumber, index) => (
              <ContactPhoneNumberRow
                phoneNumber={phoneNumber}
                key={`phoneNumber${index}`}
                handleSelect={event => handleSelect('phoneNumbers', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.emails.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel3a-header"
          >
            <Typography>E-mails ({contact?.emails.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox checked={contact?.emails.filter(item => item.checked).length == contact?.emails.length} onChange={(event) => selectAll('emails', event)} />
              <Typography sx={{ fontSize: 12 }}>Selecionar todos os e-mails</Typography>
            </div>
            {contact?.emails.map((email, index) => (
              <ContactEmailRow
                email={email}
                key={contact?.id_contato + email.id_telefone}
                handleSelect={event => handleSelect('emails', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.adresses.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel2a-header"
          >
            <Typography>Endereços ({contact?.adresses.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox checked={contact?.adresses.filter(item => item.checked).length == contact?.adresses.length} onChange={(event) => selectAll('adresses', event)} />
              <Typography sx={{ fontSize: 12 }}>Selecionar todos os endereços</Typography>
            </div>
            {contact?.adresses.map((address, index) => (
              <ContactAdressRow
                address={address}
                key={contact?.id_contato + address.id_endereco}
                handleSelect={event => handleSelect('adresses', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.companies?.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel4a-header"
          >
            <Typography>Empresas ({contact?.companies?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox checked={contact?.companies.filter(item => item.checked).length == contact?.companies.length} onChange={(event) => selectAll('companies', event)} />
              <Typography sx={{ fontSize: 12 }}>Selecionar todas as empresas</Typography>
            </div>
            {contact?.companies.map((companie, index) => (
              <ContactCompanieRow
                companie={companie}
                handleSelect={event => handleSelect('companies', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.updates?.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel4a-header"
          >
            <Typography>Edições({contact?.updates?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox checked={contact?.updates.filter(item => item.checked).length == contact?.updates.length} onChange={(event) => selectAll('updates', event)} />
              <Typography sx={{ fontSize: 12 }}>Selecionar todas as edições</Typography>
            </div>
            {contact?.updates.map((update, index) => (
              <ContactUpdateRow update={update}
                key={`update${index}`}
                handleSelect={event => handleSelect('updates', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.interactions?.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel4a-header"
          >
            <Typography>Interações({contact?.interactions?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Checkbox checked={contact?.interactions.filter(item => item.checked).length == contact?.interactions.length} onChange={(event) => selectAll('interactions', event)} />
              <Typography sx={{ fontSize: 12 }}>Selecionar todas as Interações</Typography>
            </div>
            {contact?.interactions.map((interaction, index) => (
              <ContactInteractionRow interaction={interaction}
                key={`interaction${index}`}
                handleSelect={event => handleSelect('interactions', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.apps?.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel4a-header"
          >
            <Typography>Aplicações Buildings ({contact?.apps?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10, alignItems: 'center' }}>
              <Checkbox checked={contact?.apps.filter(item => item.checked).length == contact?.apps.length} onChange={(event) => selectAll('apps', event)} />
              <Typography sx={{ width: 250, color: 'darkgray' }}>Sistema</Typography>
              <Typography sx={{ flex: 2, color: 'darkgray' }}>Login</Typography>
              <Typography sx={{ flex: 2, color: 'darkgray' }}>Último Acesso</Typography>
              <Typography sx={{ width: 70, color: 'darkgray' }}>Ativo</Typography>
            </div>
            {contact?.apps.map((app, index) => (
              <ContactAppRow
                app={app}
                key={`app${index}`}
                handleSelect={event => handleSelect('apps', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      {contact?.rdstationLeads?.length > 0 &&
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            id="panel4a-header"
          >
            <Typography>RD Station - Buildings ({contact?.rdstationLeads?.length})</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10, alignItems: 'center' }}>
              <Checkbox checked={contact?.rdstationLeads.filter(item => item.checked).length == contact?.rdstationLeads.length} onChange={(event) => selectAll('rdstationLeads', event)} />
              <Typography sx={{ width: 250, color: 'darkgray' }}>Nome</Typography>
              <Typography sx={{ flex: 2, color: 'darkgray' }}>E-mail</Typography>
            </div>
            {contact?.rdstationLeads.map((lead, index) => (
              <ContactRDStationLeadRow
                lead={lead}
                key={`rdstationLeads${index}`}
                handleSelect={event => handleSelect('rdstationLeads', index, event)}
              />
            ))}
          </AccordionDetails>
        </Accordion>
      }
      <div style={{ marginTop: 10, display: 'flex', justifyContent: 'flex-end' }}>
        <Button sx={{ marginRight: 3 }} onClick={handleCancel}>Cancelar</Button>
        <Button variant='contained' onClick={handleAnonimyzeConfirmation} >Anonimizar</Button>
      </div>
    </div>
  );

}

const ContactDetailsRow = ({ label, value }) => {

  if (!value || value == '') return

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Typography sx={{ flex: 1, maxWidth: 250, fontWeight: 700 }}>{label}</Typography>
      <Typography sx={{ flex: 2 }}>{value}</Typography>
    </div>)
}

const ContactEmailRow = ({ email, handleSelect }) => {

  const { checked = false } = email

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Typography sx={{ flex: 2 }}>{email.email}</Typography>
    </div>)
}

const ContactCompanieRow = ({ companie, handleSelect }) => {

  const { checked = false } = companie

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Typography sx={{ flex: 2 }}>{companie.nome_contato}</Typography>
    </div>)
}

const ContactPhoneNumberRow = ({ phoneNumber, handleSelect }) => {

  const { checked = false } = phoneNumber

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Typography sx={{ flex: 1, maxWidth: 150, fontWeight: 700 }}>{phoneNumber.tipo}</Typography>
      <Typography sx={{ flex: 2 }}>{phoneNumber.telefone}</Typography>
    </div>)
}

const ContactAppRow = ({ app, handleSelect }) => {

  const { checked = false } = app

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Typography sx={{ width: 200, fontWeight: 700, alignContent: 'center' }}>{app.nome_sistema}</Typography>
      <Typography sx={{ flex: 2 }}>{app.login}</Typography>
      <Typography sx={{ flex: 2 }}>{app.ultimo_acesso}</Typography>
      <Typography sx={{ width: 70 }}>{app.ativo == 1 ? 'Sim' : 'Não'}</Typography>
    </div>)
}

const ContactUpdateRow = ({ update, handleSelect }) => {

  const { checked = false } = update

  return (
    <div style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px', borderColor: 'lightgray', borderBottomStyle: 'solid', padding: 5, alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Typography sx={{ width: 150, fontWeight: 700 }}>{format(new Date(update.data_registro), 'dd/MM/yyyy')}</Typography>
      <Typography sx={{ width: 150 }}>{update.campo}</Typography>
      <Typography sx={{ flex: 1, color: update.valor_antigo == '' ? 'lightgray' : 'inheit' }}>{update.valor_antigo == '' ? 'campo vazio' : update.valor_antigo}</Typography>
      <Typography sx={{ flex: 1 }}>{update.valor_novo}</Typography>
    </div>)
}

const ContactInteractionRow = ({ interaction, handleSelect }) => {

  const { checked = false } = interaction

  return (
    <div style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px', borderColor: 'lightgray', borderBottomStyle: 'solid', padding: 5, alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Text style={{ width: 150, fontWeight: 700 }}>{format(new Date(interaction.data_interacao), 'dd/MM/yyyy')}</Text>
      <Text style={{ }}>{interaction.interacao.replace('<b>', '').replace('</b>', '').replace('<br>', ' ')}</Text>
    </div>)
}

const ContactAdressRow = ({ address, handleSelect }) => {

  const { checked = false } = address

  return (
    <div style={{ marginBottom: 20, flexDirection: 'row', alignItems: 'flex-start', display: 'flex' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <div style={{ marginLeft: 20 }}>
        <Typography>{address.endereco}{address.numero && <>, {address.numero}</>}{address.complemento && <>, {address.complemento}</>}</Typography>
        <Typography>{address.cidade}{address.uf && <> - {address.uf}</>}</Typography>
        <Typography>{address.cep}</Typography>
        <Typography>{address.pais}</Typography>
      </div>

    </div>)
}

const ContactRDStationLeadRow = ({ lead, handleSelect }) => {

  const { checked = false } = lead

  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <Checkbox checked={checked} onChange={handleSelect} />
      <Typography sx={{ width: 200, fontWeight: 700, alignContent: 'center' }}>{lead?.name}</Typography>
      <Typography sx={{ flex: 2 }}>{lead.email}</Typography>
    </div>)
}